import React from 'react';
import { observer } from 'mobx-react';
import * as IoC from 'typescript-ioc';
import Text from '../../../global/text/text';
import { DateTimeFormatter } from '../../../../infrastructure/implementations/date-formatter';
import { DateFnsFormats } from '../../../../infrastructure/date-formatter';
import { useIntl } from 'react-intl';
import { IConnectionTemplateDTO } from '../../../../api/blueprints/connection.template.types';
import DefaultButton from '../../../global/default-button/default-button';
import { Permission } from '../../../../api/roles.dao';
import { hasPermission } from '../../../../infrastructure/utils/has-permissions';
import classNames from 'classnames';
import { editText } from '../../../../constants/common-labels.constants';

type Props = {
    item: IConnectionTemplateDTO;
    isSelected: boolean;
    openEditModal: () => void;
    openTemplateDetails: (blueprintId: string) => void;
};

export const ConnectionsTemplatesListItem = observer((props: Props): JSX.Element => {
    const { item, isSelected, openEditModal, openTemplateDetails } = props;
    const intl = useIntl();

    const dateTimeFormatter = IoC.Container.get<DateTimeFormatter>(DateTimeFormatter);
    const createdAt = dateTimeFormatter.dateToFormattedString(new Date(item.createdAt), DateFnsFormats.StringifiedMonthDayYear);
    const updatedAt = item.updatedAt && dateTimeFormatter.dateToFormattedString(new Date(item.updatedAt), DateFnsFormats.StringifiedMonthDayYear);
    const hasEditPermission = hasPermission(Permission.EDIT_CONNECTION_TEMPLATES);

    const onOpenEditModal = (): void => {
        if (!hasEditPermission) return;
        openEditModal();
    };
    const cellEffectClasses = classNames({
        'active': isSelected,
        'hoverable': !isSelected,
    });

    return (
        <tr onDoubleClick={onOpenEditModal}>
            <Text tag='td' className={cellEffectClasses} message={item.name} withEllipsis />
            <Text tag='td' className={`${cellEffectClasses} created-at--column`} message={createdAt} />
            <Text tag='td' className={`${cellEffectClasses} updated-at--column`} message={updatedAt} />
            <Text tag='td' className={cellEffectClasses} message={item.description} withEllipsis />
            <td className={`${cellEffectClasses} blueprint-actions`}>
                <DefaultButton
                    text={intl.formatMessage({
                        id: 'oe.common.viewDetails',
                        defaultMessage: 'View Details',
                        description: 'Label text'
                    })}
                    modifier='cancel'
                    className='visible-while-hovered view-details'
                    onClick={() => openTemplateDetails(item.blueprintId)}
                />
                {hasEditPermission &&
                    <DefaultButton
                        text={editText()}
                        modifier='slim'
                        onClick={onOpenEditModal}
                        className='visible-while-hovered edit-template'
                    />
                }
            </td>
        </tr>
    );
});
